/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import * as IconMapping from './ocpIconMapping.json';
import { trackPage } from '../../lib/analytics-helper';
import { loadOcpFinalIntent, doServerSideFptiCall } from './action-ocpComponent';
import { OMNI_CHANNEL_ARTICLE } from '../../home/constants/PropTypesShapes';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import OmniPrompt from './OmniPrompt';
import { pathNames } from '../commonConstants';
import { CRAWL_INTENT_SEARCH_TOPIC } from '../../contactUs/constants/PropTypesShapes';

class OcpWidget extends Component {
  onOcpCardClickHandler(event, intentDummy, intentCode, searchTopicPool) {
    event.stopPropagation();
    // For contact Us
    if (this.props.pathName === pathNames.CONTACT_US) {
      return this.props.loadOcpFinalIntent(intentDummy, intentCode, searchTopicPool);
    }

    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  getContentLabel(labelPath) {
    return i18n.message(`smarthelp/ocpPrompts.${labelPath}`);
  }

  getOcpHeader(intents) {
    if (Page.isMobileLayout() || Page.isTabletLayout() || intents.length > 1) {
      return <span className="header-label">{this.getContentLabel('prefix')}</span>;
    }

    return null;
  }

  getIntentLabel(intents) {
    if (!Page.isMobileLayout() && !Page.isTabletLayout() && intents.length === 1) {
      return (this.getContentLabel('prefix'));
    }

    return '';
  }

  renderChannelSteeringWidget() {
    const {
      intentArticles, pathName, searchTopicPool,
    } = this.props;

    const { intentArticleDetails } = intentArticles;
    try {
      trackPage({ id: `${pathName}OmniChannelPromptDisplayed` });
      return (
        <div className="ocp-intents">
          {this.getOcpHeader(intentArticleDetails)}
          <div className="ocp-container-top">
            {intentArticleDetails.map((cards) => {
              doServerSideFptiCall(cards);
              const intentCode = _get(cards, 'contextMetaData.intent.intent_code', '');
              return (
                <OmniPrompt
                  intentLabel={this.getIntentLabel(intentArticleDetails, intentCode) + this.getContentLabel(intentCode)}
                  onClickHandler={(event) => this.onOcpCardClickHandler(event, cards, intentCode, searchTopicPool)}
                  intentCardIcon={`${IconMapping[intentCode]}`}
                  totalIntentsLength={intentArticleDetails.length}
                />
              );
            })}
          </div>
        </div>
      );
    } catch (e) {
      trackPage({ id: `${pathName}OmniChannelPromptError` });
      return <div />;
    }
  }

  render() {
    const { hideOmniChannelPrompt, intentArticles, isOmniChannelPromptEnabled } = this.props;

    if (isOmniChannelPromptEnabled && !hideOmniChannelPrompt && !_isEmpty(intentArticles)) {
      return this.renderChannelSteeringWidget();
    }

    // trackPage({ id: `${pathName}OmniChannelPromptNotDisplayed` });
    return <div />;
  }
}

OcpWidget.propTypes = {
  loadOcpFinalIntent: PropTypes.func.isRequired,
  isOmniChannelPromptEnabled: PropTypes.bool,
  hideOmniChannelPrompt: PropTypes.bool.isRequired,
  intentArticles: PropTypes.shape(OMNI_CHANNEL_ARTICLE),
  pathName: PropTypes.string.isRequired, // Supported pathNames: contactUs, home, miniHelp
  searchTopicPool: PropTypes.arrayOf(PropTypes.shape(CRAWL_INTENT_SEARCH_TOPIC)).isRequired,
};

OcpWidget.defaultProps = {
  isOmniChannelPromptEnabled: false,
  intentArticles: [],
};

function mapStateToProps(state) {
  return {
    intentArticles: state.ocp.omniIntents,
    isOmniChannelPromptEnabled: state.ocp.isOmniChannelPromptEnabled,
    hideOmniChannelPrompt: state.ocp.hideOmniChannelPrompt,
    searchTopicPool: state.crawlIntentTopic.searchTopicPool,
  };
}

function mapDispatchToProp(dispatch) {
  return bindActionCreators({
    loadOcpFinalIntent,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProp)(OcpWidget);
